import moment from "moment";

export default {
    data() {
        return {
            entries: [],
            paidTimeOff: [],
            payPeriods: [],
            payPeriodIndex: 0,
            errorMsg: '',
        }
    },
    methods: {
        async fetchTimecardForPayPeriod(username, start, end) {
            start = moment(start).format('YYYY-MM-DD');
            end = moment(end).format('YYYY-MM-DD');
            this.entries = await this.getEntries(start, end, username);
            const pto = await this.getPaidTimeOffForPayPeriodUser(start, end, username);
            
            this.paidTimeOff = pto.map(p => {
                if (p.username === username) {
                    return { reason: p.reason };
                }
            });
        },
        async fetchTimecard(username) {
            try {
                this.payPeriods = await this.getRanges();

                for (let i = 0; i < this.payPeriods.length; i++) {
                    let now = moment().format('YYYY-MM-DD');
                    let start = moment(this.payPeriods[i].start).format('YYYY-MM-DD');
                    let end = moment(this.payPeriods[i].end).format('YYYY-MM-DD');

                    if (now === start || now === end || moment().isBetween(moment(this.payPeriods[i].start), moment(this.payPeriods[i].end))) {
                        this.payPeriodIndex = i;
                    }
                }

                this.entries = await this.getCurrent(username);
                this.paidTimeOff = await this.getPaidTimeOffForPayPeriod(this.payPeriods[this.payPeriodIndex].start, this.payPeriods[this.payPeriodIndex].end);
            } catch (err) {
                this.errorMsg = err.message;
            }
        },
        async doClock() {
            try {
                await this.toggleClock();
                await this.fetchTimecard();
                this.$bvModal.show('timecardModal');
            } catch (err) {
                this.errorMsg = err.message;
            }
        },
        timecardTitle(username = '') {
            if (username && username.length) {
                return `Time Card for ${username}`;
            } else if (!this.payPeriods.length) {
              return 'Time Card';
            }
    
            let start = moment(this.payPeriods[this.payPeriodIndex].start).format('M/D/YYYY');
            let end = moment(this.payPeriods[this.payPeriodIndex].end).format('M/D/YYYY');
    
            return `Time Card for ${start} - ${end}`;
          }
    },
    computed: {
        isClockedIn() {
            if (!this.entries.length || this.entries[this.entries.length - 1].type === 'out') {
                return false;
            }

            return true;
        },
    },
    watch: {
        async payPeriodIndex(index) {
            this.entries = await this.getEntries(this.payPeriods[index].start, this.payPeriods[index].end);
            this.paidTimeOff = await this.getPaidTimeOffForPayPeriod(this.payPeriods[this.payPeriodIndex].start, this.payPeriods[this.payPeriodIndex].end);
        }
    }
}